module.exports = __webpack_public_path__ + "static/media/learn.787d8c63.svg";